<template>
<div class="container">
    <div class="container__card">
      <div class="container__card__wrapper">
        <div class="container__card__image"></div>
        <div class="container__card__text">
          <span class="container__card__text__upperTitle">CSS / JavaScript</span>
          <h2>Train Project</h2>
          <p>
            A customer page I made for a fictional
            Metro company to showcase the use of ES6 Javascript.
          </p>
        </div>
       <a class="container__card__footer" href="http://handig.dk/EXAM2019/index.html">
          <i class="fas fa-location-arrow fa-3x"></i>
        </a>
      </div>
      <div class="container__card__wrapper">
        <div class="container__card__image2"></div>
        <div class="container__card__text">
          <span class="container__card__text__upperTitle">CSS / JavaScript</span>
          <h2>Portfolio</h2>
          <p>
            This is my official portfolio 
            which this site is based of.
          </p>
        </div>
        <a class="container__card__footer" href="http://handig.dk/Home/index.html">
          <i class="fas fa-location-arrow fa-3x"></i>
        </a>
      </div>
      <div class="container__card__wrapper">
        <div class="container__card__image3"></div>
        <div class="container__card__text">
          <span class="container__card__text__upperTitle">Vue.js / CSS</span>
          <h2>Product Page</h2>
          <p>
            A page I built with Vue.js which consists of a 
            product page with CRUD operations, a user login
            function and a customer chat. 
          </p>
        </div>
        <a class="container__card__footer" href="https://crud-e78ec.web.app">
          <i class="fas fa-location-arrow fa-3x"></i>
        </a>
        </div>
        </div>
        </div>
</template>

<script>
export default {
  name: 'Projects',
  data() {
    return {};
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/main.scss";
</style>


// WEBPACK FOOTER //
// src/components/Projects.vue